import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})

export class TabsComponent implements OnChanges, OnInit {
  @Input()
  tabs: Array<string> = [];

  @Input()
  tabsStyle = {};

  @Input()
  newTabs = false;

  @Input()
  tabStyle: any = {};

  @Input()
  tabActiveStyle: any = {};

  @Input()
  tabHoveredStyle: any = {};

  @Input()
  activeShadowStyle: any = {};

  @Input()
  shadowMargin = 0;

  @Input()
  dicrection = 'Horizontal';

  @Input()
  showShadow = true;

  @Input()
  showHoverShadow = true;

  @Input()
  activeTabOnHover = false;

  @Input()
  activeTab = 0;

  @Input()
  justifyTabs = 'justify-content-start';

  @Output()
  selectTabEvent = new EventEmitter<any>();

  @Input()
  zeroShadowThickness;

  shadowThickness = 4;
  hoverTab = 0;
  shadow: any = { left: 0, width: 0, top: 0, height: 0 };
  activeShadow: any = { left: 0, width: 0, top: 0, height: 0 };

  transitionInit = false;

  @Input()
  hostPage;

  @Output()
  clickSelectEvent = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {

  }

  onTabHover(event) {
    if (this.showHoverShadow) {
      this.shadow.left = event.elem.nativeElement.offsetLeft;
      this.shadow.top = event.elem.nativeElement.offsetTop;
      this.shadow.width = event.elem.nativeElement.getBoundingClientRect().width;
      this.shadow.height = event.elem.nativeElement.getBoundingClientRect().height;
    }

    if (this.activeTabOnHover) {
      this.onTabActive(event);
    }
  }

  onTabChange(event) {
    this.activeTab = event.index;
    if (this.showShadow) {
      this.activeShadow.left = event.elem.nativeElement.offsetLeft;
      this.activeShadow.top = event.elem.nativeElement.offsetTop;
      this.activeShadow.width = event.elem.nativeElement.getBoundingClientRect().width;
      this.activeShadow.height = event.elem.nativeElement.getBoundingClientRect().height;
    }
    if (this.showHoverShadow) {
      this.shadow.left = event.elem.nativeElement.offsetLeft;
      this.shadow.top = event.elem.nativeElement.offsetTop;
      this.shadow.width = event.elem.nativeElement.getBoundingClientRect().width;
      this.shadow.height = event.elem.nativeElement.getBoundingClientRect().height;
    }
  }

  onTabActive(event) {
    this.onTabChange(event);
    if (event.init) {
      const timer = setTimeout(() => {
        this.transitionInit = true;
        clearTimeout(timer);
      }, 100);
    }
    this.selectTabEvent.emit(this.activeTab);
  }

  onTabClick(event) {
    this.clickSelectEvent.emit(true);
    this.onTabActive(event);
  }

  onMouseLeave() {
    if (this.showHoverShadow) {
      this.shadow.left = this.activeShadow.left;
      this.shadow.top = this.activeShadow.top;
      this.shadow.width = this.activeShadow.width;
      this.shadow.height = this.activeShadow.height;
    }
  }

  shadowStyles(isActiveShadow) {
    const style: any = {
      'transition': this.transitionInit ? 'all 0.3s ease-in-out' : 'none',
    };

    const shadowRect = this.getShadowRect(isActiveShadow);
    return { ...style, ...shadowRect, ...this.activeShadowStyle };
  }

  getShadowRect(isActiveShadow) {
    this.shadowThickness = this.zeroShadowThickness === 0 ? this.zeroShadowThickness : 4;
    const style = {};
    if (this.showShadow) {
      if (isActiveShadow && this.dicrection === 'Horizontal') {
        style['left'] = this.activeShadow.left + 'px';
        style['width'] = this.activeShadow.width + 'px';
        style['height'] = this.shadowThickness + 'px';
        style['bottom'] = 0;
        return style;
      }

      if (isActiveShadow && this.dicrection !== 'Horizontal') {
        style['top'] = this.activeShadow.top + this.shadowMargin + 'px';
        style['height'] = this.activeShadow.height - this.shadowMargin * 2 + 'px';
        style['width'] = this.shadowThickness + 'px';
        return style;
      }
    }

    if (this.showHoverShadow) {
      if (!isActiveShadow && this.dicrection === 'Horizontal') {
        style['left'] = this.shadow.left + 'px';
        style['width'] = this.shadow.width + 'px';
        style['height'] = this.shadowThickness + 'px';
        style['bottom'] = 0;
        return style;
      }

      if (!isActiveShadow && this.dicrection !== 'Horizontal') {
        style['top'] = this.shadow.top + this.shadowMargin + 'px';
        style['height'] = this.shadow.height - this.shadowMargin * 2 + 'px';
        style['width'] = this.shadowThickness + 'px';
        return style;
      }
    }
  }

  getTabsClasses() {
    if (this.dicrection === 'Horizontal') {
      if (this.newTabs) {
        return 'd-flex' + ' ' + this.justifyTabs + ' ' + 'newTabs';
      } else {
        if (this.hostPage === 'activity') {
          return 'd-flex' + ' ' + this.justifyTabs + ' ' +'activityStyle';
        }
        return 'd-flex' + ' ' + this.justifyTabs;
      }
    }
    return '';
  }

  getTabsStyles() {
    return this.tabsStyle;
  }
}
